<template>
  <div class="paginationPublic">
    <div class="paginationPublicSlide">
      <el-pagination 
      small 
      layout="prev, pager, next,jumper" 
      :page-size="15" 
      :total="totalToPag" 
      @current-change="paginCurrentChange"
      :current-page="paginationCurrentPage">
      </el-pagination>
    </div>
  </div>
</template>
<style lang='scss' scoped>
</style>
<script>
import "../../statics/css/pagination.scss";

export default {
  data() {
    return {
      pagetest:1
    }
  },
  methods: {
    //获取分页器页数
    paginCurrentChange(page) {
      this.paginationCurrentPage = page;
      this.$emit('current-change',page);
      console.log("当前页数",this.paginationCurrentPage);
    }
  },
  props: ['totalToPag',"paginationCurrentPage"]
}
</script>


// WEBPACK FOOTER //
// subPaginationCom.vue?cf04daa6